import { useEffect, useState } from "react";
import {
  productColumns,
  resources_EN,
} from "../GenericServices/componentUtils";
import DataGrid from "../Grid/DataGrid";
import AddProductModal from "./AddProductModal";
import { getService, PostService } from "../GenericServices/genericService";
import Swal from "sweetalert2";
import UpdateProductModal from "./UpdateProductModal";

const AdminProducts = ({ showAddModal, setShowAddModal }) => {
  const [products, setProducts] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editProductData, setEditProductData] = useState({});
  useEffect(() => {
    getProductAPI();
  }, []);

  /* Get Products API */
  const getProductAPI = () => {
    // Implement API call to fetch products and setProducts
    const url = "myNewAPI/get_product.php";
    getService(url, {}, getProductData);
  };

  const getProductData = (response) => {
    console.log("Productsss", response);
    const data = response.product.map((item, index) => {
      return {
        ...item,
        id: index + 1,
      };
    });
    setProducts(data);
  };

  /* Delete Confirmation Modal */
  const deleteModal = (productData) => {
    console.log("Product Data", productData);
    Swal.fire({
      title: "Delete Product",
      text: "Are you sure you want to delete this product?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#d33",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAPI(productData.prod_id);
      }
    });
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        getProductAPI();
      }
    });
  };

  /* Delete Category */
  const deleteAPI = (prodId) => {
    const url = "myNewAPI/delete_product.php";
    const data = { prod_id: prodId };
    PostService(url, data, modal);
  };

  const handleEdit = (productData) => {
    // Set product data to form and show modal
    console.log("productData", productData);
    setEditProductData(productData);
    setShowEditModal(true);
  };

  return (
    <>
      <AddProductModal
        showAddModal={showAddModal}
        setShowAddModal={setShowAddModal}
        getProductAPI={getProductAPI}
      />
      <UpdateProductModal
        showEditModal={showEditModal}
        setShowEditModal={setShowEditModal}
        editProductData={editProductData}
        getProductAPI={getProductAPI}
      />

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <DataGrid
          data={products}
          columns={productColumns}
          showActions={true}
          itemsPerPage={10}
          onRowClick={(row) => console.log(row)}
          onEdit={(product) => {
            handleEdit(product);
          }}
          onDelete={(product) => {
            // Handle delete - show confirmation, then delete
            deleteModal(product);
          }}
        />
      </div>
    </>
  );
};

export default AdminProducts;
